import React, { memo } from 'react'
import { LabelSemiBoldLarge, LabelSmall } from 'components/base-ui/FontsV2'
import { Wrapper, ThumbnailWrapper, Thumbnail, ProductLabel, DetailsWrapper } from './styled'

interface Image {
  image1x: string
  image2x: string
  image3x: string
}

export interface ProductType {
  id: number
  name: string
  label: string
  description: string
  image: Image
}

interface ProductCardProps {
  product: ProductType
  onClick: (productID: number) => void
}

const ProductCard = ({ product, onClick }: ProductCardProps) => {
  const { id, name, label, description, image } = product

  return (
    <Wrapper onClick={() => onClick(id)}>
      <ThumbnailWrapper>
        <Thumbnail image1x={image.image1x} image2x={image.image2x} image3x={image.image3x} />
        <ProductLabel>
          <LabelSmall>{label}</LabelSmall>
        </ProductLabel>
      </ThumbnailWrapper>
      <DetailsWrapper>
        <LabelSemiBoldLarge>{name}</LabelSemiBoldLarge>
        <LabelSmall>{description}</LabelSmall>
      </DetailsWrapper>
    </Wrapper>
  )
}

export default memo(ProductCard)
